import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import SurveyQuestionContext from '../../../context/surveyquestion-context';
import useStyles from "../../../styles/components/survey/stylesSurveyQuestionContainer";

const MultipleChoiceQuestionHolder = ({ tutorialSteps, index }) => {
    const classes = useStyles();
    const { surveyQuestionContext, dispatch } = useContext(SurveyQuestionContext);
    let position = 0
    if(tutorialSteps[index].type === 'MultipleChoice') {
        position = index - surveyQuestionContext.scaleContents.length
    } else {
        position = index - (surveyQuestionContext.scaleContents.length + surveyQuestionContext.multipleChoiceContents.length)
    }
    
    const getCurrentAnswerObject = (items, selectedValue) => {
        let item = items.find((item) => {
            if (item.questionOptionContent === selectedValue)
                return item
        })
        return item;
    }

    const handleChangeMultupleChoice = (event, index, content) => {
        content.selectedAnswer = getCurrentAnswerObject(content.answers, event.target.value)
        surveyQuestionContext.multipleChoiceAnswers[index] = content.selectedAnswer
        dispatch({ type: 'SET_MULTIPLECHOICE_ANSWERS', multipleChoiceAnswers: surveyQuestionContext.multipleChoiceAnswers });
    }

    const handleChangeRanking = (event, index, content) => {
        content.selectedAnswer = getCurrentAnswerObject(content.answers, event.target.value)
        surveyQuestionContext.rankingAnswers[index] = content.selectedAnswer
        dispatch({ type: 'SET_RANKING_ANSWERS', rankingAnswers: surveyQuestionContext.rankingAnswers });
    }

    return (
        <div>
            {tutorialSteps[index].type === 'MultipleChoice' ? 
                <>
                    {surveyQuestionContext.multipleChoiceContents.length > 0 &&
                        <Grid container>
                            <Typography variant='h6' className={clsx(classes.rootTypographyQuestion, classes.typographyDown)}>{surveyQuestionContext.multipleChoiceContents[position].question.questionContent}</Typography>
                            <Grid item xs={12} sm={12}>
                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="mc" name="mc1" value={Object.keys(surveyQuestionContext.multipleChoiceContents[position].selectedAnswer).length === 0 ? 0 : surveyQuestionContext.multipleChoiceContents[position].selectedAnswer.questionOptionContent} onChange={(event) => handleChangeMultupleChoice(event, position, surveyQuestionContext.multipleChoiceContents[position])}>
                                        {surveyQuestionContext.multipleChoiceContents[position].answers.map((answer, index) => (
                                            <FormControlLabel 
                                                key={index} 
                                                value={answer.questionOptionContent} 
                                                control={<Radio />} 
                                                label={answer.questionOptionContent}
                                                classes={{label: classes.typographyDown}}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    }
                </>
            :
                <>
                    {surveyQuestionContext.rankingContents.length > 0 &&
                        <>
                            <Typography variant='h6' className={clsx(classes.rootTypographyQuestion, classes.typographyDown)}>{surveyQuestionContext.rankingContents[position].question.questionContent}</Typography>
                            <Grid item xs={12} sm={12}>
                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="mc" name="mc1" value={Object.keys(surveyQuestionContext.rankingContents[position].selectedAnswer).length === 0 ? 0 : surveyQuestionContext.rankingContents[position].selectedAnswer.questionOptionContent} onChange={(event) => handleChangeRanking(event, position, surveyQuestionContext.rankingContents[position])}>
                                        {surveyQuestionContext.rankingContents[position].answers.map((answer, index) => (
                                            <FormControlLabel 
                                                key={index} 
                                                value={answer.questionOptionContent} 
                                                control={<Radio />} 
                                                label={answer.questionOptionContent} 
                                                classes={{label: classes.typographyDown}}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </>
                    }   
                </>
            }
        </div>
    )
}

export default MultipleChoiceQuestionHolder;